// @ts-nocheck
import { useParams } from 'react-router-dom';
import { formatPrice, capitalizeWords } from 'utils/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BsChevronRight, BsChevronUp } from 'react-icons/bs';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Col, Card, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getSettings } from 'store/stays/selectors';
import { CSSTransition } from 'react-transition-group';
import { BsFillInfoCircleFill, BsXCircleFill } from 'react-icons/bs';
import rightArrow from 'assets/svg/right-arrow.svg';
import React, { useState } from 'react';
import {
  getExperiencesSlowLoading,
  getExperiencesCategory,
} from 'store/experiences/selectors';
import {
  gaExperienceButtonClick,
  gaExperienceClick,
} from 'utils/google_analytics';
import './styles.scss';
import CouponCompo from 'shared_components/Coupon';

import Linkicon from 'assets/svg/link.svg';

const Tickets = ({ tickets, demo }) => {
  const settings = useSelector(getSettings);
  const params = useParams();
  const { locationTag } = params;
  const cardPressHandler = (item) => {
    window.open(`${item.product_url}&tq_campaign=${locationTag}`, '_blank');
    if (!demo) {
      gaExperienceClick(item.title, locationTag, item.id);
    }
  };

  const color = settings.custom
    ? settings.button_color
    : settings.nav_background_color;

  return (
    <Row xs={1} sm={2} md={3} lg={4} className="g-4">
      {tickets
        .filter((item) => !item?.category?.includes('Hotel Info'))
        .map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              <Restaurant item={item} demo={demo} />
              <CustomExperience item={item} demo={demo} />
              <Col
                style={{ boxShadow: '10px', display: !item.id ? 'none' : '' }}
              >
                <Card
                  onClick={() => cardPressHandler(item)}
                  className="eventbox"
                >
                  <Card.Img
                    variant="top"
                    src={item.images[0] ? item.images[0].large : ''}
                  />

                  <Card.Body>
                    <div>
                      <Card.Title
                        className="ticket_title"
                        style={{
                          fontWeight: 'bolder',
                          fontSize: 22,
                          color: 'black',
                        }}
                      >
                        {item.title}
                      </Card.Title>
                      <div className="ticket_price_rating">
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-end',
                              color: '#222222',
                            }}
                          >
                            {item?.ratings?.average ? (
                              <div className="rating">
                                <FontAwesomeIcon
                                  icon={faStar}
                                  style={{
                                    fontSize: '16px',
                                    marginRight: '4px',
                                    color: '#FFBD24',
                                    paddingBottom: 6,
                                  }}
                                />
                                {item?.ratings?.average} / 5
                                {item?.ratings?.total &&
                                  ` (${item?.ratings?.total} reviews)`}
                              </div>
                            ) : null}
                          </div>

                          <div
                            style={{
                              display: 'flex',
                              gap: 2,
                              color: 'black',
                              fontSize: 16,
                              fontWeight: 'bold',
                            }}
                          >
                            <div>From</div>
                            {/* <div>
                              {item.prediscount_price > 1 && (
                                <div
                                  style={{
                                    textDecoration: 'line-through',
                                    paddingLeft: 4,
                                  }}
                                >
                                  ${formatPrice(item.prediscount_price)}
                                </div>
                              )}
                            </div> */}
                            <Card.Text
                              style={{
                                fontWeight: 'bold',
                                fontSize: 16,
                                color: 'black',
                              }}
                            >
                              ${formatPrice(item.price)}
                            </Card.Text>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          color: '#222222',
                          fontWeight: '400',
                          fontSize: 16,
                        }}
                      >
                        <div className="ticket_tagline">{item.tagline}</div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </React.Fragment>
          );
        })}
      <LoadingSkeleton />
    </Row>
  );
};

export default Tickets;

const LoadingSkeleton = () => {
  const loading = useSelector(getExperiencesSlowLoading);
  const category = useSelector(getExperiencesCategory);
  if (!loading || !['Experiences', 'All'].includes(category)) {
    return;
  }
  return Array(10)
    .fill()
    .map((v, i) => (
      <Col key={i} style={{ boxShadow: '10px' }}>
        <Card className="eventbox skeleton">
          <div className="skeleton-grey skeleton-image" />
          <div className="skeleton-grey skeleton-text" />
          <div className="skeleton-grey skeleton-description" />
        </Card>
      </Col>
    ));
};

const CustomExperience = ({ item, demo }) => {
  const settings = useSelector(getSettings);
  const color = settings.custom
    ? settings.button_color
    : settings.nav_background_color;

  const params = useParams();
  const { locationTag } = params;

  const cardPressHandler = (item) => {
    if (item?.url?.length > 1) {
      window.open(item.url);
    }

    if (!demo) {
      gaExperienceClick(item.title, locationTag, item._id);
    }
  };

  if (!item._id || item.restaurant) {
    return;
  }

  return (
    <Col
      key={item._id}
      style={{
        boxShadow: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
        marginTop: '10px',
      }}
    >
      <Card onClick={() => cardPressHandler(item)} className="eventbox">
        <Card.Img variant="top" src={item.images[0]} className="custom_img" />
        <Card.Body>
          {item?.coupon_image && item?.coupon_image?.length > 0 && (
            <CouponCompo item={item} onClick={() => cardPressHandler(item)} />
          )}

          <div>
            <Card.Title
              className="ticket_title"
              style={{ fontWeight: 'bolder', fontSize: 22, color: 'black' }}
            >
              {item.title}
            </Card.Title>
            <div className="ticket_price_rating">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    color: '#222222',
                  }}
                >
                  {item.rating ? (
                    <div className="rating">
                      <FontAwesomeIcon
                        icon={faStar}
                        style={{
                          fontSize: '12px',
                          marginRight: '4px',
                          color: '#FFBD24',
                          paddingBottom: 6,
                        }}
                      />
                      {item.rating} / 5
                      {item?.total_rating && ` (${item?.total_rating} reviews)`}
                    </div>
                  ) : null}
                </div>
                <div>
                  {item.price > 0 && (
                    <div
                      style={{
                        display: 'flex',
                        gap: 2,
                        color: 'black',
                        fontSize: 16,
                        fontWeight: 'bold',
                      }}
                    >
                      <div>From</div>
                      <Card.Text
                        style={{
                          fontWeight: 'bold',
                          fontSize: 16,
                          color: 'black',
                        }}
                      >
                        ${formatPrice(item.price)}
                      </Card.Text>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ color: '#222222', fontWeight: '400', fontSize: 16 }}>
              <div className="ticket_tagline">{item.description}</div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

const Restaurant = ({ item, demo }) => {
  const [expanded, setExpanded] = useState(false);

  const settings = useSelector(getSettings);
  const color = settings.custom
    ? settings.button_color
    : settings.nav_background_color;

  const params = useParams();
  const { locationTag } = params;

  const cardPressHandler = (item) => {
    const firstItemUrl = item?.restaurant_info[0]?.url;
    const firstItemLable = item?.restaurant_info[0]?.label;

    if (firstItemUrl) {
      window.open(firstItemUrl);
      if (!demo) {
        gaExperienceButtonClick(
          item?.title,
          locationTag,
          firstItemLable,
          item._id
        );
      }
    }
  };

  const buttonClick = (info, item) => {
    window.open(info.url);
    if (!demo) {
      gaExperienceButtonClick(item?.title, locationTag, info?.label, item._id);
    }
  };

  if (!item.restaurant) {
    return;
  }

  return (
    <Col key={item._id} style={{ boxShadow: '10px' }}>
      <Card className="eventbox">
        <Card.Img
          variant="top"
          src={item.images[0]}
          className="custom_img"
          onClick={() => cardPressHandler(item)}
        />

        <Card.Body>
          <div>
            {item?.coupon_image && item?.coupon_image?.length > 0 && (
              <CouponCompo item={item} onClick={() => cardPressHandler(item)} />
            )}
            <div>
              <Card.Title
                className="ticket_title"
                style={{ fontWeight: 'bolder', fontSize: 22, color: 'black' }}
              >
                {item.title}
              </Card.Title>
              <div className="ticket_price_rating">
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      color: '#222222',
                    }}
                  >
                    {item.rating ? (
                      <div className="rating">
                        <FontAwesomeIcon
                          icon={faStar}
                          style={{
                            fontSize: '12px',
                            marginRight: '4px',
                            color: '#FFBD24',
                            paddingBottom: 6,
                          }}
                        />
                        {item.rating} / 5
                        {item?.total_rating &&
                          ` (${item?.total_rating} reviews) `}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    {item.price > 0 && (
                      <div
                        style={{
                          display: 'flex',
                          gap: 2,
                          color: 'black',
                          fontSize: 16,
                          fontWeight: 'bold',
                        }}
                      >
                        <div>From</div>
                        <Card.Text
                          style={{
                            fontWeight: 'bold',
                            fontSize: 16,
                            color: 'black',
                          }}
                        >
                          ${formatPrice(item.price)}
                        </Card.Text>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="restaurant_card_container_tickets">
                <div>
                  <div
                    style={{
                      color: '#222222',
                      fontWeight: '400',
                      fontSize: 16,
                    }}
                  >
                    <div
                      style={{
                        color: '#222222',
                        fontWeight: '400',
                        fontSize: 16,
                      }}
                    >
                      {/* ⭐⭐ REPLACE old ticket_tagline with this ⭐⭐ */}
                      {!expanded ? (
                        <>
                          <div
                            className="ticket_tagline"
                            onClick={(e) => {
                              e.stopPropagation(); // prevent card click
                              setExpanded(true);
                            }}
                          >
                            {item?.description}
                            <span
                              style={{
                                color: settings?.button_color,
                                cursor: 'pointer',
                                fontWeight: 600,
                              }}
                            >
                              {' '}
                              Show more
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="ticket_tagline">
                            {item.description}
                          </div>

                          {/* ⭐⭐ Buttons visible ONLY in expanded mode ⭐⭐ */}
                          {item?.restaurant_info?.map((info, i) =>
                            info?.label && info?.url ? (
                              <div
                                key={i}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  buttonClick(info, item);
                                }}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  background: '#ffffff',
                                  padding: '14px 10px',
                                  borderBottom: '1px solid #e5e5e5',
                                  marginTop: 10,
                                  cursor: 'pointer',
                                  fontSize: 16,
                                  color: '#222',
                                  fontWeight: 500,
                                }}
                              >
                                {/* LEFT TEXT */}
                                <div
                                  style={{
                                    display: 'flex',
                                    gap: 6,
                                  }}
                                >
                                  <img src={Linkicon} alt="links" />
                                  <span
                                    style={{
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    {capitalizeWords(info.label)}
                                  </span>
                                </div>

                                {/* RIGHT ARROW ICON */}
                                <div>
                                  <BsChevronRight size={22} color="#000" />
                                </div>
                              </div>
                            ) : null
                          )}

                          {/* ⭐⭐ Hide button at the end ⭐⭐ */}
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpanded(false);
                            }}
                            style={{
                              marginTop: 15,
                              padding: '12px 0',
                              background: '#f5f5f5',
                              borderRadius: 10,
                              textAlign: 'center',
                              color: settings?.button_color,
                              cursor: 'pointer',
                              fontWeight: 600,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 6,
                            }}
                          >
                            Hide{' '}
                            <BsChevronUp
                              size={18}
                              color={settings?.button_color}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};
